export default{
    insuranceTitle: 'Insurance title',
    kp: 'k.p',
    ka: 'k.a',
    kt: 'k.t',
    kOther: 'k.other',
}